import { Component, EventEmitter, inject, Input, Output, ChangeDetectionStrategy } from '@angular/core'
import { MatButton } from '@angular/material/button'
import { TranslateDirective } from '@ngx-translate/core'
import { Meeting, MeetingsService } from '../../meetings.service'

@Component({
  selector: 'app-agenda-missing-warning',
  standalone: true,
  imports: [MatButton, TranslateDirective],
  templateUrl: './agenda-missing-warning.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './agenda-missing-warning.component.scss',
})
export class AgendaMissingWarningComponent {
  @Input({ required: true })
  meeting!: Meeting

  @Output()
  openAgendaUpload = new EventEmitter<void>()

  private meetingsService = inject(MeetingsService)
  approveMissingAgendaMutation = this.meetingsService.approveMissingAgendaMutation()

  async approveMissingAgenda() {
    await this.approveMissingAgendaMutation.mutateAsync(this.meeting.id)
  }
}
